<div class="p-component pb-3 align-items-end flex justify-content-between border-bottom-2 border-primary">
  <h1 class="page-title m-0">{{pageTitle}}</h1>
  <button pButton type="button" icon="pi pi-plus" iconPos="left" label="Invite"
  (click)="showCreateForm()"></button>
</div>

<app-users-form  *ngIf="showCreate" (output)="showCreate = false"></app-users-form>

<app-users-list></app-users-list>
